
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import helper from "@/utils/helper";
import eventBus from "@/utils/eventBus";
import { CARD_CHECKED, CARD_MP_CHECKED } from "@/utils/constants";
import * as apiClient from "@/apiclient/";

export default defineComponent({
  data() {
    return {
      isAccordionOpen: false,
      helper,
      isCardChecked: false,
      isCardMpChecked: false,
      convenienceFee: 0,
    };
  },
  props: {
    benefitHeader: {
      type: String,
      required: true,
    },
    showBenefitHeader: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["getBenefitAmount", "getBenefitRates", "getEnrollment"]),
  },
  methods: {
    toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen;
    },
    handleBusCardCheckDataEvent(data: boolean) {
      this.isCardChecked = data;
    },
    handleCardCheckMpDataEvent(data: boolean) {
      this.isCardMpChecked = data;
    },
    getTotalPremiumAmount(amount: number, isCardChecked: boolean): string {
      let totalAmount = amount ? amount : 0;
      if (isCardChecked && this.getBenefitRates.amountDuePlanRates.length > 0) {
        totalAmount = totalAmount + this.convenienceFee;
      }
      return this.helper.formatNumber(totalAmount);
    },
    getTotalPremiumAmountMonthly(
      amount: number,
      isCardChecked: boolean
    ): string {
      let totalAmount = amount ? amount : 0;
      if (
        isCardChecked &&
        this.getBenefitRates.monthlyPremiumPlanRates.length > 0
      ) {
        totalAmount = totalAmount + this.convenienceFee;
      }
      return this.helper.formatNumber(totalAmount);
    },
    totalAmountDue(amountType: string) {
      let total = 0;
      if (this.getBenefitAmount.length > 0) {
        this.getBenefitAmount.forEach((value: { [key: string]: number }) => {
          if (value[amountType]) {
            total += value[amountType];
          }
        });
      }
      return total;
    },
    async getBenefitSummary(): Promise<void> {
      console.log("getBenefitSummary");
      var serviceType = this.getEnrollment.serviceType;

      if (serviceType == "1") {
        this.convenienceFee = 0;
      } else {
        const params = {
          customerParticipantId: this.getEnrollment.customerParticipantId,
        };
        const result = await apiClient
          .paymentController()
          .getApiPayment(params);
        if (result.data) {
          this.convenienceFee = result.data.convenienceFee!;
        }
      }
    },
  },
  created() {
    eventBus.on(CARD_CHECKED, (data: any) => {
      this.handleBusCardCheckDataEvent(data);
    });
    eventBus.on(CARD_MP_CHECKED, (data: any) => {
      this.handleCardCheckMpDataEvent(data);
    });
    this.getBenefitSummary();
  },
});
